let domLoaded = false;
// ig:ready may have fired before this script attached its listener
let igReady = !!window.igData?.user;

function handleExperiments() {
  
 // Test: V_WOOD_PDP_19 | Offer Framing on the Set Picker: Count vs Buy X Get Y
  // Runs as soon as Intelligems answers rather than waiting for DOMContentLoaded,
  // and igFailed means the page still gets a class when the script is blocked.
  if ((igReady || igFailed) && document.body) {
    const woodPdp19 = window.igData?.user?.getTestGroup?.(
      "62e98313-29c7-41bc-9809-773c89ca7876"
    );
    if (woodPdp19?.id === "63f5a596-076b-4703-a899-1aab267f1fbc") {
      document.body.classList.add("c-woodPdp19VarA");
    } else if (woodPdp19?.id === "ad593e5c-b3ac-48a7-bbc7-eaeaeac16763") {
      document.body.classList.add("c-woodPdp19VarB");
    } else {
      // Control, not in the test (not started / ended), or Intelligems failed to load:
      // leave the count framing
      document.body.classList.add("c-woodPdp19Control");
    }

    // Let c-wood-pdp-19.js apply the offer copy now
    document.dispatchEvent(new CustomEvent("c:experiments-applied"));
  }

  if (!domLoaded || !igReady) return;

  // Test: V_WOOD_SITE_07 | 10% Shipping Fee at Checkout vs Free Shipping
  const woodSite07 = window.igData?.user.getTestGroup(
    "3bc9359f-d442-420f-ae83-0d0c0e0fa1ae"
  );
  if (woodSite07?.id === "578b6eb0-093b-4b73-b29d-561edab58d96") {
    document.body.classList.add("c-woodSite07VarA");
  } else if (woodSite07) {
    document.body.classList.add("c-woodSite07Control");
  }

  // Let test scripts that loaded before the body classes existed run their init
  document.dispatchEvent(new CustomEvent("c:experiments-applied"));
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
